import BaseWidgetController from './base_widget_controller';

export default class extends BaseWidgetController {
  static targets = [...BaseWidgetController.targets, 'total', 'average'];

  static values = {
    ...BaseWidgetController.values,
    averageText: String,
  };

  renderData(data) {
    super.renderData(data);

    const messageData = data.task_messages;

    if (this.hasTotalTarget) {
      this.totalTarget.textContent = this.formatNumber(messageData.total);
    }

    if (this.hasAverageTarget) {
      this.averageTarget.textContent = this.averageTextValue.replace(
        /%{average}/g,
        messageData.average_per_program
      );
    }
  }

  showLoading() {
    super.showLoading();

    if (this.hasTotalTarget) {
      this.totalTarget.classList.add('opacity-50');
    }
  }

  hideLoading() {
    super.hideLoading();

    if (this.hasTotalTarget) {
      this.totalTarget.classList.remove('opacity-50');
    }
  }
}
